
<template>
    <div ref="listWrap">
        <wrapper-list
                @calculate="paasCalculate"
                ref="wrapperList" >
            <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
                <row class="list-query-row">
                    <FormItem label="售后单号:" class="list-query-item">
                        <Input  v-model="queryParam.query_LIKE_name" @on-change="queryTableDatas('param')"
                                clearable />
                    </FormItem>
                    <FormItem label="订单号:" class="list-query-item">
                        <Input  v-model="queryParam.query_LIKE_orderCode" @on-change="queryTableDatas('param')"
                                clearable />
                    </FormItem>
                </row>
                <row class="list-query-row">
                    <FormItem label="售后处理:" class="list-query-item">
                        <ButtonGroup>
                            <Button :type="checkStatus == ''? 'primary':'default'" @click.native="changeDealStatus('')">全部</Button>
                            <Button :type="checkStatus == '0'? 'primary':'default'" @click.native="changeDealStatus('0')">待审核</Button>
                            <Button :type="checkStatus == '1'? 'primary':'default'" @click.native="changeDealStatus('1')">待处理</Button>
                            <Button :type="checkStatus == '201'? 'primary':'default'" @click.native="changeDealStatus('201')">已完成</Button>
                            <Button :type="checkStatus == '202'? 'primary':'default'" @click.native="changeDealStatus('202')">用户终止</Button>
                            <Button :type="checkStatus == '203'? 'primary':'default'" @click.native="changeDealStatus('203')">客服终止</Button>
                        </ButtonGroup>
                    </FormItem>
                </row>
            </Form>
            <Table slot="table" stripe border :height="tableHeight"
                   :data="tableData"
                   :columns="tableColumns"
                   @on-selection-change="selectTableDataChange"
                   @on-sort-change="sortTableData"
                   :no-data-text="noDataText">
            </Table>
            <Page slot="page"  :total="totalRecords"
                  show-total show-sizer
                  @on-change="changePage"
                  @on-page-size-change="changePageSize">
            </Page>
        </wrapper-list>
    </div>
</template>
<script>
    import wrapperList from "@components/paas/wrapper-list";
    import metaList from "@assets/js/list/meta-list.js";
    import CellBar from '@components/paas/cell-bar'; //列表内操作
    import EnumShow from "@components/paas/enum-show";  //如果有枚举，需要引入
    export default {
        name: "list",
        mixins: [ metaList ],
        components: { wrapperList  ,CellBar},
        data() {
            return {
                serviceUrl:"/eb/order/aftersale",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                queryParam:{
                    query_LIKE_name:"",
                    query_LIKE_orderCode:"",
                    queryOrderBy_: 'applyTime@desc',
                },
                checkStatus:"",
                defaultLabelWidth:200,
                tableColumns:[
                    {
                        title: '售后单号',
                        key: 'name',
                        "fixed": "left",
                        "width": 100
                    },
                    {
                        title: '商品图片',
                        key: 'image',
                        "width": 100,
                        render:(h,params)=>{
                            if(params.row.image){
                                return h('img',{
                                    attrs: {
                                        src: params.row.image,
                                    },
                                    style:{
                                        width:"45px",
                                        height:"45px"
                                    }
                                })
                            }
                        }
                    },
                    {
                        title: '商品名称',
                        key: 'productName',
                        "width": 300,
                        render:(h,params)=>{
                            return h('div',[
                                h('p', {},"订单号:"+params.row.orderCode),
                                h('p', {},params.row.productName),
                                h('p', {},params.row.productAttr),
                                h('p', {},"货号:"+params.row.productNo),
                            ])
                        }
                    },
                    {
                        title: '买家信息',
                        key: 'createUserName',
                        "width": 160,
                        render:(h,params)=>{
                            return h('div',[
                                h('p', {},"买家昵称："+params.row.createUserName),
                                h('p', {},"收货人："+params.row.receiver),
                            ])
                        }
                    },
                    {
                        title: '实付金额',
                        key: 'payPrice',
                        "width": 80,
                    },
                    {
                        title: '订单状态',
                        key: 'orderStatus',
                        "width": 80,
                        render:(h,params)=>{
                            return h(EnumShow, {
                                props: {
                                    enumGroupCode: 'crmdict',
                                    enumCode: 'orderStatus',
                                    value: params.row.orderStatus
                                },
                                style: {
                                    color: '#3c3c3c'
                                }
                            })
                        }
                    },
                    {
                        title: '售后类型/原因',
                        key: 'aftersaleType',
                        "width": 160,
                        render:(h,params)=>{
                            return h('div',[
                                h(EnumShow, {
                                    props:{
                                        enumGroupCode:'crmdict',
                                        enumCode:'aftersaleType',
                                        value:params.row.aftersaleType
                                    },
                                    style:{
                                        color:'red'
                                    }
                                }),
                                h('p', {},"原因："+params.row.applyReason),
                            ])
                        }
                    },
                    {
                        title: '申请售后时间',
                        key: 'applyTime',
                        "width": 140,
                        "sortable": true,
                    },
                    {
                        title: '售后状态',
                        key: 'dealStatus',
                        "width": 200,
                        render:(h,params)=>{
                            return h('div',[
                                h(EnumShow, {
                                    props:{
                                        enumGroupCode:'crmdict',
                                        enumCode:'dealStatus',
                                        value:params.row.dealStatus
                                    },
                                    style:{
                                        color:'red'
                                    }
                                }),
                            ])
                        }
                    },
                    {
                        title: '审核时间',
                        key: 'verifyTime',
                        "width": 140,
                    },
                    {
                        title: '退款金额',
                        key: 'refundPrice',
                        "width": 100,
                    },
                    {
                        title: '完成时间',
                        key: 'completeTime',
                        "width": 140,
                    },
                    {
                        title: '操作',
                        "width": 200,
                        fixed: 'right',
                        render: (h, params) => {
                            let statusOperate = [];
                            let auditBtn = h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.$router.push({'path': this.setUrlFuncId("/eb/order/aftersale/auditProcess?id="+params.row.id)});
                                    }
                                }
                            }, '审核');
                            let processBtn = h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.$router.push({'path': this.setUrlFuncId("/eb/order/aftersale/auditProcess?id="+params.row.id)});
                                    }
                                }
                            }, '待处理');
                            let detailBtn = h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.$router.push({'path': this.setUrlFuncId("/eb/order/aftersale/auditProcess?id="+params.row.id)});
                                    }
                                }
                            }, '查看详情');
                            //待审核
                            if(params.row.dealStatus == "0"){
                                statusOperate.push(auditBtn);
                            }
                            //待处理
                            else if(params.row.dealStatus == "1"){
                                statusOperate.push(processBtn);
                            }
                            else{
                                statusOperate.push(detailBtn);
                            }
                            return h('div',statusOperate);
                        }
                    }
                ],
            }
        },
        mounted(){
        },
        methods:{
            changeDealStatus(status){
                this.checkStatus = status;
                if(status){
                    this.queryParam.query_EQ_dealStatus = status;
                    delete this.queryParam.query_LIKE_dealStatus;
                }else{
                    this.queryParam.query_LIKE_dealStatus = "";
                    delete this.queryParam.query_EQ_dealStatus;
                }

                this.queryTableDatas("param");
            }
        }
    }
</script>
